
import { Technician } from "@/store/modules";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export class AuthRegisterButton extends Vue {
  @Prop(Technician)
  private record!: Technician;

  @Prop(Boolean)
  loading = false;

  savingText = "Saving";

  showModal = false;

  email = "";
  password = "";
  confirmPassword = "";

  saving = false;

  error: string | null = null;
  success: string | null = null;

  showPassword = false;
  showConfirmPassword = false;

  get serverError() {
    console.log("serverError", this.$store.state);
    return this.$store.state.entities.technician.error;
  }

  mounted() {
    this.$nextTick(() => {
      const { email, cognitoID } = this.record;
      if (email && !cognitoID) {
        this.email = email;
      }
    });
  }

  @Watch('showModal')
  onShowModalChange(newVal: boolean, oldVal: boolean) {
    // If modal was closed (changed from true to false) and we have a success message,
    // emit the on-saved event to refresh the data
    if (oldVal === true && newVal === false && this.success) {
      this.$emit("on-saved", this.record.ID);
    }
  }

  get text() {
    return "Register";
  }

  onCloseModal() {
    this.showModal = false;
    this.error = null;
    this.success = null;
    this.password = '';
    this.confirmPassword = '';
    
    // Emit on-saved event when closing modal to refresh technician data
    this.$emit("on-saved", this.record.ID);
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  async onSave() {
    this.error = null;
    this.success = null;
    
    if (!this.email) {
      this.error = "Missing email";
    }

    if (!this.password) {
      this.error = "Missing password";
    }

    if (this.password !== this.confirmPassword) {
      this.error = "Passwords do not match";
    }

    if (this.error) {
      return;
    }

    this.saving = true;

    try {
      await Technician.dispatch("registerAndUpdateCognitoId", {
        techId: this.record.ID,
        email: this.email,
        password: this.password,
      });

      // Check for errors from the store
      if (
        this.$store.state.entities.technician.error &&
        this.$store.state.entities.technician.error.length
      ) {
        this.error = this.$store.state.entities.technician.error[0].message;
      } else {
        // Success - show success message (keep modal open)
        this.success = "User registered successfully! User will receive two emails shortly, their verification code and TestFlight invite.";
        this.password = '';
        this.confirmPassword = '';
        // Don't emit on-saved immediately to prevent page refresh that closes modal
        // this.$emit("on-saved", this.record.ID);
      }
    } catch (err) {
      console.error('Registration error:', err);
      this.error = err instanceof Error ? err.message : 'An unexpected error occurred';
    } finally {
      this.saving = false;
    }
  }

  async forcePasswordReset() {
    try {
      // await MR.dispatch("approve", {
      //   id: this.record.id,
      // });
    } catch (err) {
      console.error("Error occured", err, this);
    }
  }
}

export default AuthRegisterButton;
